module.exports = __webpack_public_path__ + "img/trackcomplete.d1648ff4.png";